import { BlogPostContent } from '@/types/blog';
import { einleitung } from './sections/einleitung';
import { haben_oder_sein } from './sections/haben-oder-sein';
import { kunst_des_liebens } from './sections/kunst-des-liebens';
import { fuenf_arten_der_liebe } from './sections/fuenf-arten-der-liebe';
import { praxis } from './sections/praxis';
import { meat_loaf_revisited } from './sections/meat-loaf-revisited';
import { buch_empfehlung } from './sections/buch-empfehlung';
import { fazit } from './sections/fazit';

export const content: BlogPostContent = {
  sections: [
    einleitung,
    haben_oder_sein,
    kunst_des_liebens,
    fuenf_arten_der_liebe,
    praxis,
    meat_loaf_revisited,
    buch_empfehlung,
    fazit
  ]
};
